import * as actions from './slice'
import { stackAlert } from '../toast/helpers'

// A failure used to land on `setAccountInfo` too, which stored an empty
// account and marked it loaded — the same state as an account with no
// subscription — and nothing reached a logger, so the bus timing out on a
// cold first login stayed a theory nobody could confirm in production or
// tell apart from a 4xx/5xx. The store keeps the error; this sends it on,
// the way the error boundary does.
const reportAccountInfoFailure = (error) => {
  console.error('subscriptionGetAccountInfo failed', error)
  if (window.DD_RUM && typeof window.DD_RUM.addError === 'function') {
    window.DD_RUM.addError(error, { source: 'subscriptionGetAccountInfo' })
  }
}

export const subscriptionGetAccountInfo = {
  eventName: 'subscriptionGetAccountInfo',
  onSuccess: {
    action: actions.setAccountInfo,
    redux: true
  },
  onError: [{
    action: actions.setAccountInfoError,
    redux: true
  }, reportAccountInfoFailure]
}

export const subscriptionCancel = {
  eventName: 'subscriptionCancel',
  onSuccess: {
    action: actions.setSubscriptionChangeReceived,
    redux: true
  },
  onError: [{
    action: stackAlert('Unable to cancel', 'error'),
    redux: true
  }, {
    action: actions.setSubscriptionChangeError,
    redux: true
  }]
}

export const subscriptionReactivate = {
  eventName: 'subscriptionReactivate',
  onSuccess: {
    action: actions.setSubscriptionChangeReceived,
    redux: true
  },
  onError: [{
    action: stackAlert('Unable to reactivate', 'error'),
    redux: true
  }, {
    action: actions.setSubscriptionChangeError,
    redux: true
  }]
}

export const subscriptionUpdate = {
  eventName: 'subscriptionUpdate',
  onSuccess: [{
    action: actions.setSubscriptionChangeReceived,
    redux: true
  }, {
    action: stackAlert('Subscription Plan has been updated', 'success'),
    redux: true
  }],
  onError: [{
    action: stackAlert('Unable to update', 'error'),
    redux: true
  }, {
    action: actions.setSubscriptionChangeError,
    redux: true
  }]
}

export const subscriptionCreate = {
  eventName: 'subscriptionCreate',
  onSuccess: {
    action: actions.setSubscriptionChangeReceived,
    redux: true
  },
  onError: [{
    action: stackAlert('Unable to update', 'error'),
    redux: true
  }, {
    action: actions.setSubscriptionChangeError,
    redux: true
  }]
}

export const subscriptionSuspend = {
  eventName: 'subscriptionSuspend',
  onSuccess: {
    action: actions.setSubscriptionChangeReceived,
    redux: true
  },
  onError: [{
    action: stackAlert('Unable to suspend', 'error'),
    redux: true
  }, {
    action: actions.setSubscriptionChangeError,
    redux: true
  }]
}

export const subscriptionResume = {
  eventName: 'subscriptionResume',
  onSuccess: {
    action: actions.setSubscriptionChangeReceived,
    redux: true
  },
  onError: [{
    action: stackAlert('Unable to resume', 'error'),
    redux: true
  }, {
    action: actions.setSubscriptionChangeError,
    redux: true
  }]
}

export const subscriptionRedeemCoupon = {
  eventName: 'subscriptionRedeemCoupon',
  onSuccess: {
    action: actions.setSubscriptionChangeReceived,
    redux: true
  },
  onError: [{
    action: stackAlert('Unable to apply discount', 'error'),
    redux: true
  }, {
    action: actions.setSubscriptionChangeError,
    redux: true
  }]
}
